// DefinitionPage1.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DefinitionPage.css';

const DefinitionPage1 = () => {
  const navigate = useNavigate();

  return (
    <div className="definition-overlay">
      <div className="definition-box">
        <button className="close-button" onClick={() => navigate(-1)}>×</button>
        <h2>Key Definitions - Project Achievement View</h2>

        <p className="definition-note">
          <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
        </p>

        <table className="definition-table">
          <tbody>
            <tr>
              <th>Project Name</th>
              <td>Choose the project name you want to view data for.</td>
            </tr>
            <tr>
              <th>PID</th>
              <td>Choose the project ID you want to view data for.</td>
            </tr>
            <tr>
              <th>Project Summary Table</th>
              <td>
                This table provides a complete overview of the selected project's deliverables, including both the target and achievements. It shows the total number achieved and the percentage of the target reached. Additionally, in Weekly Achievement it highlights progress up to last week—showing the achievement numbers along with the percentage change between last week’s achievement and the overall achievement.
              </td>
            </tr>
            <tr>
              <th>State wise Opscos and HD's</th>
              <td>
                This table shows you the count of resources assigned to projects, broken down by their role and state. It also includes the count of Active HDs. <br />
                <strong>Active HD</strong> - An HD is considered active if they have made at least one transaction on the wallet in the last 14 days.
              </td>
            </tr>
            <tr>
              <th>State wise Achievement count</th>
              <td>
                This table shows a breakdown of achievement counts by state for all case statuses (Open, DS, BR). It includes the total number of achievements to date, the number achieved as of last week (7 days ago), and the percentage change between last week’s achievement and the current total. This helps track weekly progress across each state.
              </td>
            </tr>
            <tr>
              <th>Employee Week wise table</th>
              <td>
                This table shows a breakdown by state and employee, providing:
                <ol>
                  <li>The count of Active HDs. (<strong>Active HD</strong> - An HD is considered active if they have made at least one transaction on the wallet in the last 14 days.)</li>
                  <li>The application count for the last 7 days (this week, days 1-7).</li>
                  <li>The application count for the previous week (last week, days 8-14).</li>
                  <li>The percentage change between this week's and last week's application counts.</li>
                </ol>
              </td>
            </tr>
            <tr>
              <th>Export Table</th>
              <td>
                With this button, you can export the data from the table into an Excel sheet. If you've applied any filters, only the filtered data that you see in the table will be downloaded.
              </td>
            </tr>
            <tr>
              <th>DI, DFL, YC</th>
              <td>
                <ul>
                  <li><strong>DI</strong> - Direct Implementation (Schemes)</li>
                  <li><strong>DFL</strong> - Digital & Financial Literacy Training</li>
                  <li><strong>YC</strong> - Yojana Card</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Case statuses</th>
              <td>
                <ul>
                  <li><strong>Open</strong> - The status indicates an application is received from the citizen and a case has been created on the HD app.</li>
                  <li><strong>Docket Submitted (DS)</strong> - Status when the application's proof of submission is uploaded on the HD app.</li>
                  <li><strong>Scheme/Document received (BR)</strong> - Status when the application's proof of benefit is uploaded on the HD app.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DefinitionPage1;
